module.exports = __webpack_public_path__ + "static/media/icon-png.dc624258.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-png.svg
// module id = 1469
// module chunks = 0